import React from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import AllCrowdFundList from "./AllCrowdFundList";
import Widgets from "./Widgets";

import useSWR from "swr";

import StatementSkeleton from "../../Components/Skeletons/StatementSkeleton";

import { APIClient } from "../../utils/api_helper";
import { useSearchParams } from "react-router-dom";

const api = new APIClient();

const loanListFetcher = async (url) => {
  const data = await api.get(url);

  return data;
};

export default function Loan({ user }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const query = new URLSearchParams(searchParams);

  // Access a specific query parameter
  // const type = query.get("type") || "";

  console.log(query, "QUERY__PARAMSSS");

  document.title = "Crowdfund | SimplyPay";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Crowdfund" pageTitle="Crowdfund" linkTo="/crowdfund" />

          {/* <SettingsSkeleton> */}
          {/* {stats && ( */}
          <React.Fragment>
            {/* <StatementSkeleton>{stats && <Widgets data={stats} />}</StatementSkeleton> */}

            <AllCrowdFundList />
          </React.Fragment>
          {/* )} */}
          {/* </SettingsSkeleton> */}
        </Container>
      </div>
    </React.Fragment>
  );
}
